import Image from "next/image";
import { useEffect, useState } from "react";
import MobileSlider from "./mobileSlider";
import { toWebp } from "@/utils/common";

type systemProps = {
  data?: any;
  isMobile?: boolean;
};

const Systems: React.FC<systemProps> = ({ isMobile, data  }) => {
  const baseUrl = process.env.NEXT_PUBLIC_REACT_APP_RESOURCE_BASE_URL ?? "";
  const [openId, setOpenId] = useState(null);

  const [isClient, setIsClient] = useState(false);

  useEffect(() => {
    setIsClient(true);
  }, []);

  const handleClick = (id: any) => {
    if (!isClient) return; // skip SSR
    if (window.matchMedia("(pointer: coarse)").matches) {
      setOpenId((prev) => (prev === id ? null : id));
    }
  };

  return (
    <section className="relative bg-background-white text-primary-text py-[56px] xl:py-[100px] md:py-[83px] overflow-hidden">
      <div className="container mx-auto px-4 text-center relative z-10">
        <div className="flex flex-col items-start justify-start mx-auto">
          <div className="grid md:grid-cols-12 gap-6 md:gap-[30px] items-center w-full">
            <div className="sm:text-left xl:col-span-12 md:col-span-12">
              <h2 className="text-heading-1 font-bold text-primary-text text-center xl:mb-[40px] mb-[32px] md:mt-[-0] max-w-[1230px] mx-auto">
                {data?.title}
              </h2>
            </div>
          </div>

          {!isMobile && (
            <>
              {data?.coreFeature?.map((feature: any, index: number) => (
                <div
                  key={index}
                  className="p-[24px] pb-[48px] last:pb-[0] mb-[24px] border-border border-b-1 last:border-b-0 w-full"
                >
                  <div className="grid md:grid-cols-12 gap-6 md:gap-[30px] items-start w-full ">
                    <div className="sm:text-left xl:col-span-5 md:col-span-6 xl:h-[220px] h-[180px] flex xl:items-center md:items-center justify-center ">
                      <h3 className="text-heading-3 font-bold text-primary-text text-left mb-[0]">
                        {feature?.title}
                      </h3>
                    </div>
                    <div className="sm:text-left xl:col-span-7 md:col-span-6 xl:h-[220px] h-[180px] flex items-center justify-center">
                      <p className="ms-auto max-w-[576px] text-secondary-text text-subtitle-2">
                        {feature?.description}
                      </p>
                    </div>
                  </div>

                  <div className="noise-bg mt-[32px] relative h-[360px] w-full overflow-hidden group">
                    <div
                      className="absolute bg-cover bg-center h-[360px]  w-full "
                      style={{
                        backgroundImage: `url(${toWebp(`${baseUrl}${feature?.image?.data?.attributes?.url}`)})`,
                      }}
                    ></div>

                    <div
                      onClick={() => handleClick(feature?.id)}
                      className={`${openId === feature?.id ? "md:translate-y-0" : "md:translate-y-[80%] "} absolute z-40 cursor-pointer group xl:opacity-0 backdrop-blur-[10px] xl:hover:opacity-100 xl:translate-y-4 xl:hover:translate-y-0 md:hover:translate-y-0 transition-all duration-500 ease-in-out flex items-center flex-col justify-center h-full w-full `}
                    >
                      <div
                        className="absolute opacity-40 bg-cover bg-center h-full w-full"
                        style={{
                          backgroundImage:
                            "url(/images/manufacturing/blur-1.png)",
                        }}
                      ></div>

                      <div
                        className={` ${openId === feature?.id ? "md:hidden" : "md:block"} text-center mb-[16px] relative z-10 xl:hidden  md:translate-y-[-60px] group-hover:hidden `}
                      >
                        <h2 className="text-white text-subtitle-2 mb-0 font-semibold ">
                          {feature?.features?.title}
                        </h2>
                      </div>

                      <div className="text-center mb-[16px] relative z-10">
                        <h2
                          className="text-white text-subtitle-2 mb-0 font-semibold "
                          style={{ animationDelay: "200ms" }}
                        >
                          {feature?.features?.title}
                        </h2>
                      </div>

                      {/* Features list */}
                      <div
                        className={`${openId === feature?.id ? " " : " max-h-[112px]"} flex justify-center relative z-10 gap-4 flex-wrap xl:max-w-[1000px] max-w-[800px]`}
                      >
                        {feature?.features?.feature?.map(
                          (item: any, i: number) => {

                            return (
                              <div
                                key={item.id || i}
                                className="flex items-center justify-center bg-white h-[48px]"
                              >
                                <div
                                  className={`
                                  ${
                                    i % 2 === 0
                                      ? "bg-blue-50 text-blue-600"
                                      : "bg-green-50 text-green-600"
                                  }
                                  p-2 h-[48px] w-[48px] flex items-center justify-center
                                `}
                                >
                                  {item?.tag_image?.data?.attributes?.url && (
                                    <Image
                                      src={toWebp(
                                        `${baseUrl}${item?.tag_image?.data?.attributes?.url}`,
                                      )}
                                      height={24}
                                      width={24}
                                      alt={item?.feature_title}
                                    />
                                  )}
                                </div>
                                <span className="font-semibold text-secondary-text text-left text-subtitle-2 mt-1 px-[8px]">
                                  {item?.feature_title}
                                </span>
                              </div>
                            );
                          },
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          )}

          {isMobile && (
            <MobileSlider dotColor="#B0D9F7">
              {data?.coreFeature?.map((feature: any, index: number) => (
                <div
                  key={index}
                  className="p-[24px_0px] pb-[0] mb-[0] border-border border-b-0"
                >
                  <div className="grid md:grid-cols-12 gap-6 md:gap-[30px] items-start w-full ">
                    {/* Title */}
                    <div className="sm:text-left xl:col-span-5 md:col-span-6 xl:h-[220px] md:h-[180px] flex xl:items-center md:items-start justify-center ">
                      <h3 className="text-heading-3 font-bold text-primary-text text-center mb-[12px] md:mb-[0] md:mt-[-0]">
                        {feature.title}
                      </h3>
                    </div>

                    {/* Description */}
                    <div className="sm:text-left xl:col-span-7 md:col-span-6 xl:h-[220px] md:h-[180px] flex items-center justify-center">
                      <p className="ms-auto max-w-[576px] text-secondary-text text-subtitle-2 mb-[24px]">
                        {feature.description}
                      </p>
                    </div>
                  </div>

                  {/* Feature Block */}
                  <div className="noise-bg mt-[32px] relative h-[424px] w-full overflow-hidden">
                    {/* Background */}
                    <div
                      className="absolute bg-cover bg-center h-full w-full "
                      style={{
                        backgroundImage: `url(${toWebp(feature.backgroundImage || "/images/manufacturing/sys-1.png")})`,
                      }}
                    ></div>

                    <div className="absolute top-0 p-[48px_24px] lg:opacity-0 opacity-100 backdrop-blur-[10px] hover:opacity-100 xl:translate-y-4 hover:translate-y-0 transition-all duration-500 ease-in-out flex items-center flex-col justify-start h-full w-full">
                      <div
                        className="absolute top-0 opacity-40 bg-cover bg-center h-full w-full"
                        style={{
                          backgroundImage: `url(${toWebp(feature.blurImage || "/images/manufacturing/blur-1.png")})`,
                        }}
                      ></div>

                      {/* Core Features Title */}
                      <div className="text-left mb-[16px] relative z-10 w-full">
                        <h2 className="text-white text-left text-subtitle-2 mb-0 font-semibold">
                          Core Features
                        </h2>
                      </div>

                      {/* Features List */}
                      <div className="flex justify-start relative z-10 gap-[12px] flex-wrap max-w-[400px] ml-0 mr-auto">
                        {feature?.features?.feature?.map(
                          (item: any, i: number) => {

                            return (
                              <div
                                key={item.id || i}
                                className="flex items-center justify-center bg-white h-[48px] opacity-100 animate-hover-fadeScale"
                                style={{ animationDelay: `${i * 200}ms` }}
                              >
                                <div
                                  className={`
                                  ${
                                    i % 2 === 0
                                      ? "bg-blue-50 text-blue-600"
                                      : "bg-green-50 text-green-600"
                                  }
                                  p-2 h-[48px] w-[48px] flex items-center justify-center
                                `}
                                >
                                  {item.tag_image?.data?.attributes?.url && (
                                    <Image
                                      src={toWebp(
                                        `${baseUrl}${item.tag_image?.data?.attributes?.url}`,
                                      )}
                                      height={24}
                                      width={24}
                                      alt={item.feature_title}
                                    />
                                  )}
                                </div>
                                <span className="font-semibold text-secondary-text text-left text-subtitle-2 mt-1 px-[8px]">
                                  {item.feature_title}
                                </span>
                              </div>
                            );
                          },
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </MobileSlider>
          )}
        </div>
      </div>
    </section>
  );
}

export default Systems;
